import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const VideoSeekbarPreviewHls = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { clip } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "relative max-h-[100px] w-[172px] min-w-[172px]",
        style: {
            paddingBottom: "".concat(clip.height / clip.width * 100, "%")
        },
        children: /*#__PURE__*/ _jsx("video", {
            className: "absolute inset-0 size-full object-contain",
            ref: forwardedRef
        })
    });
});
VideoSeekbarPreviewHls.displayName = "VideoSeekbarPreviewHls";
